import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { UtilityService } from 'src/app/service/utility.service';
import { WebsocketTransferService } from 'src/app/service/websocket-transfer.service';
import { environment } from 'src/environments/environment';
// import { PeriodicElement } from '../track-attendee-dialog/track-attendee-dialog.component';
// import 


export interface attachmentElement {
  attachReview: string;
  position: number;
}

const attachmentData: attachmentElement[] = [
  {position: 1, attachReview: 'User-Manual.pdf'},
  
];

export interface task {
  linkReview: string;
  position: number;
}

const taskToReview: task[] = [
  {position: 1, linkReview: 'Completed the Agora to be review popup  Assinged to Lavanaya  Due: Apr 27, 2022'},
  {position: 2, linkReview: 'Completed the Agora to be review popup  Assinged to Mohan  Due: Apr 27, 2022'},
];

@Component({
  selector: 'app-project-status-dialog',
  templateUrl: './project-status-dialog.component.html',
  styleUrls: ['./project-status-dialog.component.css'],
  providers:[DatePipe]
})
export class ProjectStatusDialogComponent implements OnInit {

  options: any
  today : any
  currentDate : any

  disabled = false;
  compact = true;
  invertX = false;
  invertY = false;

  //UI Team Change variable
  meetingInfoData : any

  shown: 'native' | 'hover' | 'always' = 'native';
  hide: any;
  hideUseTemplate: any;
  existMeetingId:any;
  selTemplate:any;
  emptyAgenda="<br/>"
  constructor(private globals: Globals,private datePipe: DatePipe,private utilityService: UtilityService,private matDailogRef: MatDialogRef<ProjectStatusDialogComponent>,@Inject(MAT_DIALOG_DATA) data:any,@Inject(MAT_DIALOG_DATA) dataTwo:any,@Inject(MAT_DIALOG_DATA) dataThree:any, private meetingService: MeetingService,private sideNav : SideNavServiceService,private webTranService:WebsocketTransferService,private activatedRouter: ActivatedRoute, private router:Router,) { 
    this.meetingInfoData = data;
    this.hide = dataTwo.hide
    this.hideUseTemplate = dataThree.hideUseTemplate
    this.existMeetingId = data.existMeetingId;
    this.selTemplate = data.selTemplate;  
  }
 fullDate:any;
  ngOnInit(): void {
    this.options = {
      weekday : 'long',
      month : 'short',
      day : 'numeric',
      year : 'numeric'
    }  
    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US",this.options)
    const rawDateStr = this.meetingInfoData.meetingData.meetingDateStr; // 'April 24, 2025'
  const parsedDate = new Date(rawDateStr); // Convert to Date object

  // Format to "Monday, April 24, 2025"
  if(this.meetingInfoData.meetingData.meetingDateStr != undefined){
    this.fullDate = this.datePipe.transform(parsedDate, 'fullDate');
  }
  
       
  }

  displayedColumns: string[] = ['position', 'attachReview'];
  dataSource = new MatTableDataSource<attachmentElement>(attachmentData);

  displayedTaskColumns: string[] = ['position', 'tskReview'];
  dataTaskSource = new MatTableDataSource<task>(taskToReview);

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatPaginator)
  paginatorTask!: MatPaginator;
  meetingObj: any = {};
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataTaskSource.paginator = this.paginatorTask;
  }

  viewMeeting(meetingObj: any) {
      if(meetingObj.isDummyLink!=null && meetingObj.isDummyLink=="Y"){
      this.createRecurChildMeeting(meetingObj).then((res: any) => {
        if (res != null && res.body != null && res.body.meetingId != null) {
          if (res.body.meetingStartFlag == "Y") {
            this.startMeeting(res.body.meetingId);
          } else {
            this.redirectToMeeting(res.body.meetingId);
          }
        }
      });
    } else {
      if (meetingObj.meetingStatusCode == 'SCH') {
        if (meetingObj.meetingStartFlag == 'Y') {
          this.startMeeting(meetingObj.meetingId);
        } else {
          this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meetingObj.meetingId, "flag": true, "meetingStartFlag": "" }) }, skipLocationChange: true, replaceUrl: false });
          this.matDailogRef.close();
        }
      } else {
        this.redirectToMeeting(meetingObj.meetingId);
      }
    }

  }


  createRecurChildMeeting(obj:any){
    return new Promise((resolve, reject) => {
      var reqJson ={
        "recurDetailsId": obj.recurDetailsId,
        "meetingDateStr": obj.meetingDateStr,
        "meetingStartTime": obj.meetingStartTime,
        "orgCode": this.globals.orgCode,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone
      }
      this.meetingService.createRecurChildMeeting(reqJson).subscribe(res => {
        resolve(res);
        // if(res!=null && res.body!=null && res.body.meetingId!=null){
        //   if(res.body.meetingStartFlag=="Y"){
        //     this.startMeeting(res.body);
        //   }else{
        //     this.redirectToMeeting(res.body);  
        //   }
        // }
      });
    });
  }

  startMeeting(meetingId:any){
    var jsonObj = {
      "meetingId":meetingId,
      "userId":localStorage.getItem("userId")
    }
    this.meetingService.startMeeting(jsonObj).subscribe((meetingRes: any) => {
        this.sideNav.openInstantMeeting(true);
        var reqJson={"meetingId":meetingId,"userId":localStorage.getItem("userId"),"loggedStatus":"LOGIN"}
        this.webTranService.pushUserLoggedInStatus(meetingId,reqJson).subscribe((data) => {
        });
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId }) }, skipLocationChange: true, replaceUrl: false });  
        this.matDailogRef.close();
      },
      err => {
      });

   }

  redirectToMeeting(meetingId:number){
    this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meetingId }) }, skipLocationChange: true, replaceUrl: false });  
    this.matDailogRef.close();
  }

  loadTemplateData(template:any) {
    var reqJSON={"templateName":template.selTemplate,"meetingId":this.existMeetingId, "orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"templateId":template.templateId,"isCopyMinutes":'N',"includeAgenda":'Y',"includeAttendee":'Y'};
    if(this.existMeetingId!=undefined || this.existMeetingId!=null){
      this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
        this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.existMeetingId }) }, skipLocationChange: true, replaceUrl: false });  
        this.matDailogRef.close();
      })
    }else{
      this.meetingObj = {};
      this.meetingObj = {
        "meetingDateStr": this.utilityService.nvl(this.utilityService.getDefaultMeetingDate()),
        "meetingStartTime": this.utilityService.nvl(this.utilityService.getDefaultMeetingTime()),
        "orgCode": this.globals.orgCode,
        "userId": this.globals.userId,
        "visitorTimeZone": this.globals.vTimeZone,
        "duration": environment.defMeetingDuration,
        "logType":this.globals.logType,
        "meetingTitle":template.selTemplate
      }
      this.meetingService.createNewMeeting(this.meetingObj).subscribe(data => {
        if (data != null && data != undefined && data.body != null && data.body != undefined) {
          if (data.body.meetingId != null) {
            reqJSON={"templateName":template.selTemplate,"meetingId":data.body.meetingId, "orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId"),"templateId":template.templateId,"isCopyMinutes":'N',"includeAgenda":'Y',"includeAttendee":'Y'};
            this.meetingService.loadTemplate(reqJSON).subscribe((responseObj:any)=>{
              this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : data.body.meetingId }) }, skipLocationChange: true, replaceUrl: false });  
              this.matDailogRef.close();
            });
          }
        }
      })
    }
}



}
